<!-- ── En-tête "Tout (dé)sélectionner" ─────────────────────────────────────── -->
@if (showSelectAll) {
  <div class="tree-select-all">
    <input
      type="checkbox"
      class="node-checkbox"
      [checked]="allChecked"
      [indeterminate]="someChecked && !allChecked"
      (change)="toggleSelectAll($event)"
    />
    <span class="tree-select-all__label">{{ 'GLOBAL.SELECT_ALL' | translate }}</span>
  </div>
}

<div class="tree-wrapper">

  <div class="tree-scroll-content" #scrollContent (scroll)="onScroll()">
    <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl" class="explore-tree">
      <cdk-tree-node
        *cdkTreeNodeDef="let node"
        class="tree-node"
        [attr.data-level]="node.level"
        [attr.data-node-id]="node.id"
        [attr.data-node-key]="node.type + ':' + node.id"
        [attr.data-attr]="'treeview-node-' + node.type + '-' + node.id"
        [style.padding-left]="getIndent(node.level)"
        [style.display]="shouldRender(node) ? 'block' : 'none'"
        (click)="onNodeClick(node, $event)"
      >
        @for (i of getGuideIndices(node); track i) {
          <span
            class="tree-guide"
            [style.left.px]="i * 20 + 25"
          ></span>
        }
        <div class="node-inner" [class.node-inner--selected]="isSelected(node)">

          <input
            type="checkbox"
            class="node-checkbox"
            [checked]="node.checked"
            (change)="toggleChecked(node, $event)"
            (click)="$event.stopPropagation()"
            [attr.data-attr]="'treeview-check-' + node.type + '-' + node.id"
          />

          <span
            class="node-label"
            [class.node-label--ellipsis-start]="labelEllipsis === 'start'"
            (mouseenter)="onLabelEnter($event)"
            (mouseleave)="onLabelLeave()"
          ><span class="node-label__text">{{ node.label }}</span></span>

          <!-- Badge "Open" — émet badgeClick -->
          @if (node.badge) {
            <span class="node-badge" (click)="onBadgeClick(node, $event)" [attr.data-attr]="'treeview-badge-' + node.type + '-' + node.id">
              <span class="badge-text">{{ node.badge | translate }}</span>
              <svg class="badge-icon" xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                <path d="M0.382399 15.6478C0.137548 15.4222 0 15.1163 0 14.7974C0 14.4784 0.137548 14.1725 0.382399 13.947L6.84743 7.99274L0.382399 2.03852C0.144487 1.81166 0.0128441 1.50781 0.0158195 1.19242C0.018795 0.877029 0.156153 0.575335 0.398309 0.352312C0.640464 0.12929 0.968041 0.00278664 1.31049 4.57764e-05C1.65294 -0.00269508 1.98285 0.118547 2.22918 0.33766L9.6176 7.14231C9.86245 7.36788 10 7.67378 10 7.99274C10 8.3117 9.86245 8.6176 9.6176 8.84317L2.22918 15.6478C1.98425 15.8733 1.65211 16 1.30579 16C0.959466 16 0.627322 15.8733 0.382399 15.6478Z" fill="#121212"/>
              </svg>
            </span>
          }

          <!-- Expand/collapse -->
          @if (node.expandable) {
            <svg class="expand-icon"
                 [class.expand-icon--open]="isExpanded(node)"
                 [attr.data-attr]="'treeview-expand-' + node.type + '-' + node.id"
                 (click)="treeControl.toggle(node); $event.stopPropagation(); onToggle()"
                 xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10" fill="none">
              <path d="M0.35 9.62C0.58 9.86 0.88 10 1.2 10C1.52 10 1.82 9.86 2.05 9.62L8 3.15L13.95 9.62C14.18 9.86 14.48 9.99 14.8 9.99C15.12 9.99 15.42 9.85 15.64 9.61C15.86 9.37 15.99 9.04 15.99 8.7C15.99 8.36 15.87 8.03 15.65 7.78L8.86 0.38C8.63 0.14 8.33 0 8.01 0C7.69 0 7.39 0.14 7.16 0.38L0.35 7.77C0.12 8.01 0 8.35 0 8.69C0 9.03 0.13 9.37 0.35 9.61V9.62Z" fill="#121212"/>
            </svg>
          }

        </div>
      </cdk-tree-node>
    </cdk-tree>
  </div>

  @if (showScrollbar) {
    <div class="scrollbar-track" #scrollTrack (click)="onTrackClick($event)">
      <div
        class="scrollbar-thumb"
        [style.height.px]="thumbHeight"
        [style.top.px]="thumbTop"
        (mousedown)="onThumbMouseDown($event)"
      ></div>
    </div>
  }

</div>